import { useQuery } from '@tanstack/react-query';

import { exercisesService } from '../services';
import type { ReviewQueueStatus } from '../types';

interface UseExerciseReviewQueueParams {
  organizationId?: string;
  locationId?: string;
  status?: ReviewQueueStatus;
  search?: string;
  clientId?: string;
}

export const exerciseReviewQueueKeys = {
  all: ['exercises', 'review-queue'] as const,
  scoped: (params: UseExerciseReviewQueueParams) =>
    [
      'exercises',
      'review-queue',
      {
        organizationId: params.organizationId ?? null,
        locationId: params.locationId ?? null,
        status: params.status ?? null,
        search: params.search ?? null,
        clientId: params.clientId ?? null,
      },
    ] as const,
};

/**
 * Exercises the logged-in practitioner has assigned that the client has
 * finished. Returns both `completed` (awaiting review) and `reviewed`
 * rows by default; pass `status` to narrow. `staleTime: 0` so the list
 * reflects new completions as soon as the practitioner returns to the
 * page. Org / location come from the global tenant scope picker.
 */
export function useExerciseReviewQueue(params: UseExerciseReviewQueueParams = {}) {
  return useQuery({
    queryKey: exerciseReviewQueueKeys.scoped(params),
    queryFn: () => exercisesService.listReviewQueue(params),
    staleTime: 0,
  });
}
